import { createFileRoute, redirect } from '@tanstack/react-router'

// Корень админки — флот: юниты живут на своём разделе с deep-link на юнит.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/units' })
  },
})
